module.exports = __webpack_public_path__ + "media/images/shoretime_white-05c1fd4e5c992d1836e2e0876417cd69.png";